import api from "src/api/axiosInstance";

export const fetchSearchedProducts = async (searchQuery) => {
  try {
    const response = await api.get(
      `/productsearch/${searchQuery}?page=1&limit=10000`
    );
    if (response.data.status === 0) {
      return response.data.data;
    }
    return [];
  } catch (error) {
    console.error("Error fetching products:", error);
    return [];
  }
};
